import './index.scss';
import { useContext } from 'react';
import { AppLabel, AppText, FlexColumn, FlexRow, TextInput } from 'src/style';
import { UsersCard } from '../UsersCard';
import { Header } from 'src/component/Layout';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import { Search } from 'src/assets/icon';
import { HomeScreenProps } from '../types';
import { getAllStudentsInClass, getStudentsList } from 'src/utils/helpers';

export const TeacherHome = ({ user }: HomeScreenProps) => {
    const { info } = useContext(AppInfoContext);
    const students = getStudentsList(info);
    const numberOfStudent = getAllStudentsInClass(students, user?.profile?.memberClass).length

    return (
        <div className='teacher-home'>
            <Header user={user}>
                <TextInput
                    width='44'
                    topPadding='1.2'
                    leftPadding='2.5'
                    rightPadding='2.5'
                    bottomPadding='1.2'
                    className='search-container'
                >
                    <input type="text" placeholder='search...' />
                    <Search />
                </TextInput>
            </Header>

            <FlexRow className='content-wrapper' justifyContent='space-between'>
                <UsersCard className='students-list' title='Students' list={students} />
                <FlexColumn className='other-details' justifyContent='space-between'>
                    <FlexRow>
                        <FlexColumn className='flex-student-count' alignItems='end'>
                            <AppLabel>Students</AppLabel>
                            <AppText className='disc-text'>{numberOfStudent}</AppText>
                        </FlexColumn>
                        <FlexColumn className='flex-class-name' alignItems='end'>
                            <AppLabel>Class</AppLabel>
                            <AppText className='disc-text'>{user?.profile?.memberClass}</AppText>
                        </FlexColumn>
                    </FlexRow>
                    <FlexRow className='caption-constainer' justifyContent='end'>
                        <AppText className='caption-text'>
                            “Teaching is the <br />
                            greatest act <br />
                            of optimism.”
                        </AppText>
                    </FlexRow>
                </FlexColumn>
            </FlexRow>
        </div>
    )
}
